import React from "react";

import { listFormat } from "~/lib/utils";
import Tooltip from "~/ui/Tooltip";

import styles from "./SimpleUserList.module.css";

export function SimpleUserList({
	names,
	limit = 5,
	tooltip = true,
	boldNames = false,
}: {
	names: readonly string[];
	limit?: number;
	tooltip?: boolean;
	boldNames?: boolean;
}) {
	if (names.length === 1) {
		return boldNames ? <b>{names[0]}</b> : <>{names[0]}</>;
	} else if (names.length <= limit + 1) {
		return (
			// eslint-disable-next-line react/no-array-index-key
			<>{listFormat(names.map((name, i) => (boldNames ? <b key={i}>{name}</b> : <span key={i}>{name}</span>)))}</>
		);
	} else {
		const shownNames: React.ReactNode[] = names
			.slice(0, limit)
			// eslint-disable-next-line react/no-array-index-key
			.map((name, i) => (boldNames ? <b key={i}>{name}</b> : <span key={i}>{name}</span>));
		const nOthers = <>{names.length - limit} others</>;
		shownNames.push(
			tooltip ? (
				<Tooltip
					content={
						<span className={styles.simpleUserListTooltip}>
							<SimpleUserList tooltip={false} names={names.slice(limit)} limit={15} />
						</span>
					}
				>
					{boldNames ? <b key="others">{nOthers}</b> : nOthers}
				</Tooltip>
			) : (
				nOthers
			),
		);
		return (
			<>
				{listFormat(shownNames).map((name, i) => (
					// eslint-disable-next-line react/no-array-index-key
					<span key={i}>{name}</span>
				))}
			</>
		);
	}
}
